<template lang="pug">
.v-collection-lg-card.collection-lg-card(v-if="data")
	.collection-lg-card__background(:style="{background: data.background}")
	.collection-lg-card__header
		.collection-lg-card__header-left
			.collection-lg-card__name(v-if="data.name" ) {{ data.name }}
			h4.collection-lg-card__title(v-if="data.title" ) {{ data.title }}
		.collection-lg-card__header-right
			.collection-lg-card__tags(v-if="data.tags" )
				.collection-lg-card__tag.tag(v-for="(tag, index) in data.tags" :key="index" )
					.tag__text(v-if="tag.text" ) {{ tag.text }}
	.collection-lg-card__body
		.collection-lg-card__body-left
			.collection-lg-card__visual-left
				img.collection-lg-card__image-left(
					v-if="data.imageLeft"
					:src="data.imageLeft?.src"
					:alt="data.imageLeft?.alt")
			.collection-lg-card__body-buttons
				a.btn.btn--lg.btn-gap( v-if="data.link" :href="data.link?.href")
					| {{data.link?.text}}
					.btn-arrow.btn__icon
						.btn-arrow__track
							.btn-arrow__track-item
								v-svg-icon.icon-arrow(icon="btn-arrow")
							.btn-arrow__track-item
								v-svg-icon.icon-arrow(icon="btn-arrow")
		.collection-lg-card__body-right
			.collection-lg-card__visual-right
				img.collection-lg-card__image-right(
					v-if="data.imageRight"
					:src="data.imageRight?.src"
					:alt="data.imageRight?.alt")


</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>